export enum MainProcessTypeEnum {
  // ProcessType for offer.
  ACQUISITION = 'ACQUISITION',
  RETENTION = 'RETENTION',
  MNP = 'MNP',
  UPSELL = 'UPSELL',
  PREPAID_2_POSTPAID = 'PREPAID_TO_POSTPAID', // Migration
  OTHER_SALES = 'DEVICE_ONLY',
}

